import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

const SelectableListCardLoading = () => {
  return (
    <>
      {[1, 2].map((index) => (
        <Card
          variant="outlined"
          data-testid={'selectable-list-card-loading'}
          key={index}
        >
          <CardContent sx={{ p: 2, '&:last-child': { paddingBottom: 2 } }}>
            <Stack
              direction="row"
              flexWrap="wrap"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack sx={{ mr: 2 }}>
                <Skeleton variant="circular" width={40} height={40} />
              </Stack>
              <Stack flexDirection="column" sx={{ maxWidth: '80%' }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Skeleton variant="text" width={800} height={40} />
                </Stack>
                <Skeleton variant="text" width={800} height={40} />
              </Stack>
              <Stack marginLeft="auto">
                <Skeleton variant="rectangular" width={100} height={40} />
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default SelectableListCardLoading;
